import type { Profile } from '@models/session';

import type { AccountModel } from 'generated/types';
import type { GetUserRecordQuery } from 'generated/user.generated';

import { formatPatientId } from './format';

type UserProfileProps = Omit<
  GetUserRecordQuery['getUserRecord'],
  'account' | 'users' | 'created_at' | 'updated_at' | 'status'
> & {
  account?: Pick<AccountModel, 'account_id' | 'parent_id'>;
};

export const mapProfile = (user?: UserProfileProps): Profile | null => {
  if (!user) {
    return null;
  }
  return {
    ...user,
    account_id: user.account_id,
    email: user.email,
    first_name: user.first_name,
    last_name: user.last_name,
    user_id: user.user_id,
    roles: user.roles,
    patient_id: formatPatientId(user.vitall_patient?.patient_id),
    vitall_patient_id: user.vitall_patient?.vitall_patient_id ?? null,
    account: {
      ...user.account,
      account_id: user.account_id,
      isManaged: Boolean(user.account?.parent_id),
    },
  };
};

export const mapProfiles = (users: UserProfileProps[]): Profile[] => {
  return users.map((user) => {
    return {
      ...user,
      account_id: user.account_id,
      email: user.email,
      first_name: user.first_name,
      last_name: user.last_name,
      user_id: user.user_id,
      roles: user.roles,
      patient_id: formatPatientId(user.vitall_patient?.patient_id),
      vitall_patient_id: user.vitall_patient?.vitall_patient_id ?? null,
      account: {
        ...user.account,
        account_id: user.account_id,
        isManaged: Boolean(user.account?.parent_id),
      },
    };
  });
};
